<template>
  <div>
    <div v-if="!showEsim">
      <slot name="unshowEsimText"></slot>
    </div>
    <div v-if="showEsim" class="sim-type-selection  mt-5 mb-5">
      <p><slot name="beforeSimTypeSelectionLabel"><strong>SIM-Typ wählen</strong>*</slot></p>
      <div class="option-boxes">
        <div class="option-image" :class="{'highlight-option': simType_ === SimTypes.simCardCode}">
          <slot name="optionClassic">Klassisch</slot>
        </div>
        <div class="option-image option-image-esim" :class="{'highlight-option': simType_ === SimTypes.eSimCode}">
          <slot name="optionEsim">eSIM</slot>
        </div>
      </div>
      <b-form-group>
        <b-form-radio-group v-model="simType_" required>
          <b-form-radio id="selectSimCard" name="simType" :value="SimTypes.simCardCode" class="mr-5">
            <slot name="lblClassicSim">{{ SimTypes.simCardLabel }}
              <span class="glyphicon glyphicon-question-sign" aria-hidden="true"></span>
              <span class="question-icon" data-toggle="modal" data-target=".sim-card-modal"></span>
            </slot>
          </b-form-radio>
          <b-form-radio id="selectESim" name="simType" :value="SimTypes.eSimCode">
            <slot name="lblESim">{{ SimTypes.eSimLabel }}
              <span class="glyphicon glyphicon-question-sign" aria-hidden="true"></span>
              <span class="question-icon" data-toggle="modal" data-target=".e-sim-modal"></span>
            </slot>
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <div v-if="simType_ === SimTypes.eSimCode">
        <slot name="afterSimTypeSelectionDescription">
          Deine eSIM wird in der Regel nach 2 Stunden per Mail zur Verfügung gestellt. <br>
          In Ausnahmefällen kann die Bereitstellung bis zu 24 Stunden andauern.<br>
          Ist dein Gerät eSIM-fähig? <a href="#" data-toggle="modal" data-target=".esim-device-check-modal">Prüfe es hier</a>
        </slot>
      </div>
      <!-- SIM-Card Modal -->
      <div class="modal fade sim-card-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h2 class="modal-title">{{ SimTypes.simCardLabel }}</h2>
              <button type="button" aria-label="Close" data-dismiss="modal" class="close">×</button>
            </div>
            <div class="modal-body">
              <slot name="modalSimTypeCard">
                Eine klassische SIM-Karte ist die, die Du schon kennst. Sie ist für jedes Endgerät geeignet. Wir senden Dir eine Multiformat-Karte, die sogenannte Triple SIM, zu und Du nutzt einfach das Format, welches in Dein Endgerät passt.
              </slot>
            </div>
          </div>
        </div>
      </div>
      <!-- /SIM-Card Modal -->
      <!-- eSIM Modal -->
      <div class="modal fade e-sim-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h2 class="modal-title">{{ SimTypes.eSimLabel }}</h2>
              <button type="button" aria-label="Close" data-dismiss="modal" class="close">×</button>
            </div>
            <div class="modal-body">
              <slot name="modalSimTypeESim">
                Die <strong>eSIM</strong> ist eine eingebettete SIM-Karte und dient wie die auswechselbare physische Karte zur Identifikation des Nutzers im Mobilfunknetz. Die Teilnehmerinformationen sind in einem verlöteten Modul des mobilen Endgeräts gesichert eingebettet und können per Software geändert werden.
              </slot>
            </div>
          </div>
        </div>
      </div>
      <!-- /eSIM Modal -->
    </div>
  </div>
</template>

<script>
import syncProperty from '@/mixins/syncProperty'
import { SimTypes } from '@/helper/SimTypes'
export default {
  name: 'SimTypeSelection',
  components: {},
  data () {
    return {
      SimTypes
    }
  },
  mixins: [
    syncProperty('simType', 'simType_')
  ],
  computed: {
    selectedSimType () {
      return this.simtype_
    }
  },
  props: {
    showEsim: {
      type: Boolean,
      default: false
    }
  }
}
</script>
